import content from './content/deposits-and-withdrawals.json';

export const depositsAndWithdrawalsMock = {
  name: 'deposits-and-withdrawals',
  layoutType: 1,
  areasList: [
    {
      id: 'deposits-and-withdrawals-main',
      componentName: 'Comp:DepositsAndWithdrawalsPage',
      content: JSON.stringify(content)
    }
  ]
};
